import React, { useContext, useEffect, useRef, useState } from 'react'
import useCallout from '../../hooks/useCallout'
import { ICallout } from '../../models/Callout'
import LoaderContext from '../context/FormLoader'
import CalloutDisplay from '../common/CalloutDisplay'
import Conditional from '../common/Conditional'
const WorkplaceBasicsInfo = () => {
  const mountedRef = useRef(false)
  const [data, setData] = useState<ICallout[]>([])
  const [getCallout] = useCallout('WorkplaceBasicQuiz', 'Before')
  const [isLoading, setIsLoading] = useState(true)
  const loader = useContext(LoaderContext)

  useEffect(() => {
    mountedRef.current = true
    loader.up()
    if (mountedRef.current) {
      getCallout()
        .then((response) => {
          if (mountedRef.current) {
            setData(response.callouts)
          }
        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => {
          setIsLoading(false)
          loader.down()
        })
    }
    return () => {
      mountedRef.current = false
    }
  }, [])

  return (
    <>
      <h1> Workplace basics </h1>
      <Conditional if={!isLoading}>
        {data &&
          data.map((c, i) => (
            <CalloutDisplay
              key={i}
              className=""
              content={c.content}
              name="WorkplaceBasicQuiz"
            />
          ))}
      </Conditional>
    </>
  )
}

export default WorkplaceBasicsInfo
